var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"centered":_vm.centered,"hide-header-close":"","hide-footer":"","size":_vm.size,"title":_vm.title},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }